import * as React from 'react';

export const SurveyResponsesTable: React.FC<{}> = ({}) => {
    return <div>Place to display survey responses table</div>;
};

export default SurveyResponsesTable;
